import { NumberFieldUI } from '@axo/form/feature/form-input/NumberField/NumberFieldUI';
import { useTranslation } from '@axo/shared/i18n';
import { Grid } from '@axo/ui-core/components/layout/item';
import { PersonFormGroupData } from '../../../FormData.no.types';
import { gridColumns } from '../../../config/layouts/grid';
import { socialSecurityNumberFieldOptions } from '../../shared-config';

export const PersonFormGroup = () => {
  const { t } = useTranslation();

  return (
    <Grid columns={gridColumns}>
      <NumberFieldUI<PersonFormGroupData>
        name="Person/SocialSecurityNumber"
        label={t('SocialSecurityNumber.label')}
        data-testid="ssn-input"
        {...socialSecurityNumberFieldOptions}
      />
    </Grid>
  );
};
